import { useState } from 'react';
import { testimonials } from '@/mocks/articles';

export default function ReviewSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
            （瓜友热评）
          </h2>
        </div>

        <div className="max-w-2xl mx-auto relative">
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0 mt-1">
              <div className="px-4 py-2 bg-foreground-900 text-accent-500 rounded-full text-sm font-bold flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                {t.rating}
              </div>
            </div>
            <div className="flex-1">
              <blockquote className="font-heading text-lg md:text-xl text-foreground-700 leading-relaxed italic">
                "{t.comment}"
              </blockquote>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden">
                  <img src={t.avatar} alt={t.username} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.username}</p>
                  <p className="text-xs text-foreground-400">{t.platform}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 right-0 flex items-center gap-2">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-300 text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="上一条评论"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-white hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="下一条评论"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}